import SearchFillIcon from '@/components/icons/SearchFillIcon'
import GuestsFillIcon from '@/components/icons/GuestsFillIcon'
import TripsFillIcon from '@/components/icons/TripsFillIcon'
import LoginFillIcon from '@/components/icons/LoginFillIcon'
import bookmarkFillIcon from '@/components/icons/BookmarkFillIcon'
import HomeIcon from '@/components/icons/HomeIcon'
import HomeIconFill from '@/components/icons/HomeIconFill'
import { checkIsWhiteLabel } from '@/helpers/checkEnvironments'

const isWhiteLabel = checkIsWhiteLabel()
type Links = {
  link: string
  title: string
  isLogin: boolean
  icon: () => React.JSX.Element
}
const homeLink: Links = {
  link: '/',
  title: 'خانه',
  isLogin: false,
  icon: isWhiteLabel ? HomeIconFill : HomeIcon,
}

const searchLink: Links = {
  link: '/search',
  title: 'اقامتگاه‌ها',
  isLogin: false,
  icon: SearchFillIcon,
}
const bookmarkLink: Links = {
  link: '/bookmarks',
  title: 'علاقه‌مندی‌ها',
  isLogin: false,
  icon: bookmarkFillIcon,
}
const tripsLink: Links = {
  link: '/trips',
  title: 'سفرهای من',
  isLogin: false,
  icon: TripsFillIcon,
}

export const defaultLinks = [
  homeLink,
  searchLink,
  { ...bookmarkLink, isLogin: true },
  {
    link: '/login',
    title: 'ورود|ثبت نام',
    isLogin: true,
    icon: LoginFillIcon,
  },
]

export const guestLinks = [homeLink, searchLink, bookmarkLink, tripsLink]
export const hostLinks = [
  homeLink,
  {
    link: '/panel/host',
    title: 'پنل میزبان',
    isLogin: false,
    icon: GuestsFillIcon,
  },
  searchLink,
  tripsLink,
]
